import React from "react";

export const formatMoney = (number) => {
  return parseInt(number)
    .toLocaleString("en-US", { style: "currency", currency: "USD" })
    .split(".")[0];
};

export const PartnerAlternativeMetricRenderer = (pam, idx) => {
  if (pam.partnerMetricType === "Document") {
    return (
      <p key={idx} style={{ marginBottom: "2px" }}>
        <span style={{ fontWeight: "bold" }}>{pam.partnerMetricName}: </span>
        <a href={pam.partnerAlternativeMetricValue} target="_blank">
          {
            pam.partnerAlternativeMetricValue.split("/")[
              pam.partnerAlternativeMetricValue.split("/").length - 1
            ]
          }
        </a>
      </p>
    );
  }

  if (pam.partnerMetricType === "Link") {
    return (
      <p key={idx} style={{ marginBottom: "2px" }}>
        <span style={{ fontWeight: "bold" }}>{pam.partnerMetricName}: </span>
        <a href={pam.partnerAlternativeMetricValue} target="_blank">
          {pam.partnerAlternativeMetricValue}
        </a>
      </p>
    );
  }

  if (pam.partnerMetricType === "Image") {
    return (
      <img
        key={idx}
        style={{ width: "100%" }}
        src={pam.partnerAlternativeMetricValue}
        alt="image"
      />
    );
  }

  if (pam.partnerMetricType === "Address (Map)") {
    const coordsArray = pam.partnerAlternativeMetricExtraValue.split(",");
    if (coordsArray.length == 2) {
      const url = `http://maps.google.com/maps?q=${coordsArray[0]},${
        coordsArray[1]
      }`;
      return (
        <p key={idx} style={{ marginBottom: "2px" }}>
          <span style={{ fontWeight: "bold" }}>{pam.partnerMetricName}: </span>
          <a href={url} target="_blank">
            {pam.partnerAlternativeMetricValue}
          </a>
        </p>
      );
    } else {
      return <></>;
    }
  }

  return (
    <p key={idx} style={{ marginBottom: "2px" }}>
      <span style={{ fontWeight: "bold" }}>{pam.partnerMetricName}: </span>
      {pam.partnerMetricName.toLowerCase() == "price"
        ? formatMoney(pam.partnerAlternativeMetricValue)
        : pam.partnerAlternativeMetricValue}
    </p>
  );
};
